<div class="reg_container">
    <div class="Page_container">
        <div class="reg_content">
            <div class="title_content">
                <h2>Normativa PSD2</h2>
            </div>
            <div class="columns">
                <div class="forms_container">
                    <div class="termsUse">
                        <h4>¿Qué es la normativa PSD2?</h4>
                        <p class="sep-paragraph">
                            La Directiva de Servicios de Pago (llamada PSD2 por sus siglas en inglés) es una normativa
                            de la Unión Europea que regula la prestación de los servicios de pago electrónicos.
                            Principalmente refuerza la seguridad de las operaciones financieras y de los pagos
                            electrónicos.
                            El objetivo de la PSD2 es crear un mercado único de pagos en la Unión Europea, fomentando la
                            competencia, innovación y eficiencia, haciendo los pagos electrónicos más fáciles y sobre
                            todo más seguros.
                        </p>
                        <h4>¿Realmente te afecta?</h4>
                        <p class="sep-paragraph">
                            Como muchas otras normativas, incorpora varias modificaciones que debes conocer. Ten en
                            cuenta que todas ellas están dirigidas a proporcionarte una mayor transparencia y
                            protección.
                        </p>
                        <h4>¿Cuáles son las modificaciones que más te interesan conocer?</h4>
                        <ul class="sep-paragraph">
                            <li>En caso de que detectemos en nuestros sistemas que una operación ha podido ser
                                fraudulenta o sea sospechosa de fraude, nos pondremos en contacto contigo para que nos
                                confirmes que sí has realizado esta operación.</li>
                            <li>Solo se considerarán autorizadas las operaciones cuando hayas dado tu consentimiento
                                para que se produzca dicha operación.</li>
                            <li>El plazo de resolución de reclamaciones relacionadas con los servicios de pago se
                                reducirá a 15 días, y en situaciones excepcionales a un mes.</li>
                            <li><span class="color-text">Más seguridad en tus operaciones online:</span> Han aumentado los requisitos
                                de seguridad cuando vayas a realizar todas tus compras o pagos online, aplicando un
                                procedimiento reforzado de autenticación.</li>
                            <li><span class="color-text">Nuevo sistema de autenticación reforzada en dos factores:</span> ¿Cómo
                                funciona? Ahora, para que realices tus operaciones a través de banca electrónica con la
                                máxima seguridad, tendrás que introducir un código OTP que enviaremos a tu móvil para
                                completar el registro en el Espacio Cliente. Posteriormente, cada 90 días, al acceder a
                                tu Espacio Cliente, volveremos a enviarte un código OTP que deberás introducir tras
                                incluir tu DNI y clave. ¡Recuerda tener tu móvil actualizado en la sección de datos
                                personales en tu Espacio Cliente!</li>
                        </ul>
                        <p class="sep-paragraph">

                            Como ves, la llegada de la nueva normativa viene cargada de buenas noticias.

                        </p>
                        <h4>Derechos y obligaciones de los consumidores en materia de servicios de pago:</h4>
                        <p class="sep-paragraph">
                            La normativa de la Unión Europea facilita que los pagos electrónicos sean más baratos,
                            fáciles y seguros. En el enlace que te facilitamos a continuación puedes consultar tus
                            derechos como consumidor al realizar pagos en Europa.
                        </p>
                        <h4>Descubre a continuación la información a la que tienen acceso.</h4>
                        <p class="sep-paragraph">
                            Con la PSD2, los proveedores de servicios de pago terceros (proveedores de servicios de
                            iniciación de pagos, proveedores de información sobre cuentas y proveedores de servicios de
                            pago que emitan instrumentos de pago basados en tarjetas, en su conjunto llamados
                            “Proveedores terceros”), pueden tener acceso a la información de las cuentas de pago de los
                            clientes en las entidades de crédito. <br>
                            Esto supone que estos proveedores terceros, autorizados por sus clientes, podrán acceder a
                            sus cuentas de pago para poder iniciar en su nombre una transacción de pago y/o recuperar el
                            estado y transacciones o movimientos de la cuenta con el fin de ofrecer servicios de valor
                            añadido.
                        </p>
                        <p class="color-text">En nuestro caso, utilizamos un proveedor externo autorizado, Afterbanks/Arcopay, para
                            recopilar de forma segura los datos de agregación bancaria. Gracias a esta integración
                            basada en la normativa PSD2, podemos ofrecerte una visión consolidada y actualizada de tus
                            cuentas bancarias con todas las garantías de seguridad y privacidad exigidas por la
                            legislación europea.</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<app-footer-landing></app-footer-landing>